"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspendedAmountService = void 0;
const SuspendedAmountServiceLive_1 = require("./SuspendedAmountServiceLive");
const SuspendedAmountServiceStub_1 = require("./SuspendedAmountServiceStub");
class SuspendedAmountService {
    static create(stub = false) {
        if (stub) {
            return new SuspendedAmountServiceStub_1.SuspendedAmountServiceStub();
        }
        return new SuspendedAmountServiceLive_1.SuspendedAmountServiceLive();
    }
}
exports.SuspendedAmountService = SuspendedAmountService;
//# sourceMappingURL=SuspendedAmountService.js.map